<template>
    <div>
        <v-search v-if="show">
            <router-link :to="{path:'add'}">
                <a-button v-if="this.$route.path=='/mingdan/list'" type="primary" class="fr opbuttonmt">新增</a-button>
            </router-link>条件筛选
        </v-search>
        <v-tablelist></v-tablelist>
    </div>
</template>

<script>
import TableList from "./tablelist.vue";
import Search from "./search.vue";

export default {
    data() {
        return {
            show: true
        };
    },
    methods: {},
    computed: {},
    components: {
        "v-tablelist": TableList,
        "v-search": Search
    },
    beforeMount() {
        if (this.$route.path.indexOf("/zhixing") > -1) {
            this.show = false;
        }
    },
    mounted() {}
};
</script>

<style scoped>
</style>